import { render, staticRenderFns } from "./dyeingAndFinishingOrderPrint.vue?vue&type=template&id=0520a173&scoped=true"
import script from "./dyeingAndFinishingOrderPrint.vue?vue&type=script&lang=js"
export * from "./dyeingAndFinishingOrderPrint.vue?vue&type=script&lang=js"
import style0 from "./dyeingAndFinishingOrderPrint.vue?vue&type=style&index=0&id=0520a173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520a173",
  null
  
)

export default component.exports